import React from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import Form from "../../../components/forms/LoginForms";
import { loginAction } from "../../../../../utils/login";
import PublicPage from "../../../components/PublicPage";

const onSubmit = loginAction(
  "/opravneny-organ/api/auth/basic",
  "/opravneny-organ/funkcionari",
);

const ConnectedForm = connect(null, { onSubmit, goBack })(Form);

export default () => (
  <PublicPage title="Přihlášení oprávněného orgánu">
    <ConnectedForm
        title="Přihlášení oprávněného orgánu"
        role={"legitimate"}
    />

    <div className="publicLoginSupport">
      <div className="publicLoginSupport__row">
        Podpora pro uživatele:{" "}
        <a
            className="publicLoginSupport__email"
            href="mailto:cro@msp.justice.cz"
        >
          cro@msp.justice.cz
        </a>
      </div>
      <a
          className="publicLoginSupport__faq"
          href="https://justice.cz/web/msp/casto-kladene-otazky"
      >
        Často kladené dotazy (FAQ)
      </a>
    </div>
  </PublicPage>
);
